/**
 * Created by lihanying on 2017/7/6.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData, getCurrentTimeByType } from '../../util/index'
import { message } from 'antd'
import {
  GETPAYMENTLIST,
  GETBUSINESS,
  GETPERIOD,
  GETRECORDDETAIL,
} from './constants'
import { CLUB_ID } from '../ClubBusiness/constants'

export const getPaymentList = (payload) => {
  return {
    type: GETPAYMENTLIST,
    payload,
  }
}
export const getBusiness = (payload) => {
  return {
    type: GETBUSINESS,
    payload,
  }
}

export const getPeriod = (payload) => {
  return {
    type: GETPERIOD,
    payload,
  }
}
export const getRecordDetail = (payload) => {
  return {
    type: GETRECORDDETAIL,
    payload,
  }
}

//支付方式
export function fetchPaymentList(id) {
  return (dispatch, getState) => {
    const club = sessionStorage.getItem(CLUB_ID)
    const endpoint = `${API_DOMAIN}/BusinessApi/IncomeMember/club_id/${club}/typeId/${id}`
    return fetchData(endpoint).then((data) => {
      dispatch(getPaymentList(data.payList))
    })
  }
}

//显示
export function fetchIncomeBusiness(body) {
  'use strict'
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/IncomeMember`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      dispatch(getBusiness(data.list))
      return data
    })
  }
}

export function fetchTimePeriod(type) {
  return (dispatch, getState) => {
    dispatch(getPeriod(getCurrentTimeByType(type)))
  }
}

//订单号
export function fetchRecordDetails(temporary_number) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/RecordDetails/sn/${temporary_number}`
    return fetchData(endpoint).then((data) => {
      dispatch(getRecordDetail(data))
    })
  }
}

export function fetchSnDetails(account) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/SnDetails`
    return postData(endpoint, 'POST', JSON.stringify({ sn: account })).then(
      (data) => {
        dispatch(getRecordDetail(data))
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Consume/action.js